import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-11026a78")

_pushScopeId("data-v-11026a78")
const _hoisted_1 = { class: "ui__navigation_main" }
const _hoisted_2 = { class: "ui__head_top_logo" }
const _hoisted_3 = {
  key: 0,
  class: "ui__head_top_logoImg"
}
const _hoisted_4 = { class: "ui__head_topMore_box" }
const _hoisted_5 = { class: "ui__head_topMore" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_model_cover" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "ui__head_top_logoMsg",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openNav && _ctx.openNav(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.state.currentName) + " ", 1),
        _createVNode("i", {
          class: {'ui__show':_ctx.state.isShowTopTab}
        }, null, 2)
      ]),
      (_ctx.state.channelType !== 'lingshou')
        ? (_openBlock(), _createBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.ceilingList, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: "head-check-item",
            key: item.id,
            onClick: ($event: any) => (_ctx.clickTab(item.name))
          }, _toDisplayString(item.name), 9, ["onClick"]))
        }), 128))
      ]),
      _hoisted_6
    ], 512), [
      [_vShow, _ctx.state.isShowTopTab]
    ])
  ], 512)), [
    [_vShow, _ctx.state.isShowTopNav]
  ])
})